export const SCHEDULE_TIME_MAX = {
  hour: 23,
  minute: 59,
  second: 59,
};

const clampScheduleTimePart = (value, max) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.min(Math.max(0, n), max);
};

/** Clamp time to 00:00:00–23:59:59 (API format). */
export const clampScheduleTimeValue = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const match = raw.match(/^(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
  if (!match) {
    if (/^\d{1,2}$/.test(raw)) {
      return String(clampScheduleTimePart(raw, SCHEDULE_TIME_MAX.hour));
    }
    return raw;
  }

  const hour = clampScheduleTimePart(match[1], SCHEDULE_TIME_MAX.hour);
  const minute = clampScheduleTimePart(match[2], SCHEDULE_TIME_MAX.minute);
  const second = clampScheduleTimePart(match[3] ?? 0, SCHEDULE_TIME_MAX.second);

  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:${String(second).padStart(2, "0")}`;
};

/** Normalize API time (`00:03:00`). */
export const normalizeTimeValue = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  const match = raw.match(/^(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
  if (!match) return raw;
  return clampScheduleTimeValue(raw);
};

export const splitScheduleTimeParts = (value) => {
  const normalized = normalizeTimeValue(value);
  if (!normalized) {
    return { hour: "", minute: "", second: "" };
  }
  const [hour, minute, second] = normalized.split(":");
  return { hour, minute, second };
};

export const joinScheduleTimeParts = (hour, minute, second) => {
  if (!String(hour ?? "").trim() && !String(minute ?? "").trim() && !String(second ?? "").trim()) {
    return "";
  }
  return clampScheduleTimeValue(
    `${hour || "00"}:${minute || "00"}:${second || "00"}`
  );
};
